import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class RoleService {

    getEventRoute = '/api/role/';

    constructor(private dataService: DataService) {
    };

    getMenu(refresh: Boolean) {
        return this.dataService.getJsonData('./assets/json/staticdata/role.json');
        //return this.dataService.getData('/api/user/menu', refresh);
    }

}
